import 'jodit/build/jodit.min.css'

import { Jodit } from 'jodit'
import React, { ChangeEvent, forwardRef, useEffect, useLayoutEffect, useRef } from 'react'
import { ExtendableStyles, Testable } from 'utils-next/types'

export type JoditEditorProps = Testable &
  ExtendableStyles & {
    config: object
    id?: string
    name?: string
    onBlur?: (html: string) => void
    onChange?: (html: string) => void
    tabIndex?: number
    value: string
  }

export const JoditEditor = forwardRef((props: JoditEditorProps, ref) => {
  const { config, id, name, onBlur, onChange, tabIndex, value, ...otherProps } = props

  const textArea = useRef<any>(null)

  useLayoutEffect(() => {
    if (ref) {
      if (typeof ref === 'function') {
        ref(textArea.current)
      } else {
        ref.current = textArea.current
      }
    }
  }, [textArea])

  useEffect(() => {
    const element = textArea.current
    textArea.current = Jodit.make(element, config)
    textArea.current.workplace.tabIndex = tabIndex || -1

    // adding event handlers
    textArea.current.events.on(
      'blur',
      (value: ChangeEvent<HTMLInputElement>) => onBlur && onBlur(value.target.innerHTML)
    )
    textArea.current.events.on('change', (value: string) => onChange && onChange(value))

    if (id) {
      element.id = id
    }
    if (name) {
      element.name = name
    }
  }, [config])

  useEffect(() => {
    if (textArea?.current?.value !== value) {
      textArea.current.value = value
    }
  }, [value])

  return <textarea ref={textArea} {...otherProps} />
})

JoditEditor.displayName = 'JoditEditor'
